import { AuthState } from "@/store/auth/state";

export const getOngoingCallByChatId = (chatId: string, state: AuthState) => {
  const currentCall = state.ongoingCalls.calls.find(
    (call) => call.chatId === chatId,
  );

  return currentCall ?? null;
};
